import { render, staticRenderFns } from "./meetDetail.vue?vue&type=template&id=4dd5bb94&scoped=true&"
import script from "./meetDetail.vue?vue&type=script&lang=js&"
export * from "./meetDetail.vue?vue&type=script&lang=js&"
import style0 from "./meetDetail.vue?vue&type=style&index=0&id=4dd5bb94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd5bb94",
  null
  
)

export default component.exports